import * as React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import * as modalActions from '../../../actions/modals';

class ModalConnector extends React.Component {
  onClose = () => {
    this.props.onClose(this.props.name);
  };

  render() {
    const {isOpen, data, children} = this.props;

    if(!isOpen) {
      return null;
    }

    return children({
      isOpen,
      data,
      onClose: this.onClose,
    });
  }
}

ModalConnector.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,

  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default connect(
  (state, ownProps) => ({
    isOpen: state.modal.isOpen && state.modal.name === ownProps.name,
    data: state.modal.data,
  }),
  {
    onClose: modalActions.close,
  }
)(ModalConnector);
